module.exports = __webpack_public_path__ + "static/media/2_pl.e739765f.png";